import { render, staticRenderFns } from "./stuAppSignView.vue?vue&type=template&id=fbfae2be&"
import script from "./stuAppSignView.vue?vue&type=script&lang=js&"
export * from "./stuAppSignView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports